// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallsAnalysisShared_wrapper_1EBZq"};